import { render, staticRenderFns } from "./EmptyIllustration.vue?vue&type=template&id=563b6a5e&scoped=true&"
import script from "./EmptyIllustration.vue?vue&type=script&lang=js&"
export * from "./EmptyIllustration.vue?vue&type=script&lang=js&"
import style0 from "./EmptyIllustration.vue?vue&type=style&index=0&id=563b6a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b6a5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('563b6a5e')) {
      api.createRecord('563b6a5e', component.options)
    } else {
      api.reload('563b6a5e', component.options)
    }
    module.hot.accept("./EmptyIllustration.vue?vue&type=template&id=563b6a5e&scoped=true&", function () {
      api.rerender('563b6a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/illustrations/EmptyIllustration.vue"
export default component.exports